export const teacherTypeConstants = new Map([
    ['100', '学科普通教师'],
    ['200', '学科骨干教师'],
    ['300', '德育普通教师'],
    ['400', '德育骨干教师']
]);

export const positionConstants = new Map([
    ['1', '校长'],
    ['2', '副校长'],
    ['12', '书记'],
    ['25', '副书记'],
    ['26', '纪委书记'],
    ['28', '教务主任'],
    ['29', '办公室主任'],
    ['30', '德育主任'],
    ['31', '电教中心主任'],
    ['32', '总务主任'],
    ['33', '团支部书记'],
    ['34', '工会主席'],
    ['35', '办公室副主任'],
    ['36', '工会副主席'],
    ['37', '教科室主任'],
    ['38', '心理教师'],
    ['39', '校医'],
    ['40', '校长助理'],
    ['41', '主任'],
    ['42', '副主任'],
    ['46', '信息中心主任'],
    ['47', '副校长(含主持工作)'],
    ['48', '园长'],
    ['49', '副园长'],
    ['50', '园长助理'],
    ['51', '督学'],
    ['52', '行政中心主任'],
    ['53', '年级组长'],
    ['54', '教研组长'],
    ['200', '教导主任'],
    ['201', '班主任'],
    ['202', '老师'],
    ['203', '保育员'],
    ['204', '保健员'],
    ['205', '厨师'],
    ['206', '保安'],
    ['207', '其他'],
    ['208', '其他管理人员'],
]);

export const honoraryTitleConstants = new Map([
    ['1', '中小学正高级教师'],
    ['2', '中小学高级教师'],
    ['3', '中小学一级教师'],
    ['4', '中小学二级教师'],
    ['5', '中小学三级教师'],
    ['16', '未定职级'],
    ['17', '教授'],
    ['18', '副教授'],
    ['19', '讲师（高校）'],
    ['20', '助教（高校）'],
    ['21', '正高级讲师（中专）'],
    ['22', '高级讲师（中专）'],
    ['23', '讲师（中专）'],
    ['24', '助理讲师（中专）'],
    ['25', '教员（中专）'],
    ['26', '正高级讲师（技校）'],
    ['27', '高级讲师（技校）'],
    ['28', '讲师（技校）'],
    ['29', '助理讲师（技校）'],
    ['30', '教员（技校）'],
    ['32', '高级实习指导教师'],
    ['33', '一级实习指导教师'],
    ['34', '二级实习指导教师'],
    ['35', '三级实习指导教师'],
    ['36', '无职称'],
]);

export const peopleStateConstants = new Map([
    ['11', '在职'],
    ['01', '退休'],
    ['02', '离职'],
    ['05', '调出'],
    ['04', '返聘'],
    ['06', '辞职'],
    ['08', '开除'],
    ['09', '下落不明'],
    ['03', '死亡'],
    ['12', '延聘'],
    ['13', '待退休'],
    ['14', '长病假'],
    ['15', '因公出国'],
    ['16', '停薪留职'],
    ['17', '待岗'],
    ['99', '其他'],
]);

export const allPeopleStateConstants = new Map([
    ['11', '在职'],
    ['1000', '流出'],
    ['1005', '流入'],
    ['1010', '校外'],
    ['01', '退休'],
    ['02', '离职'],
    ['05', '调出'],
    ['04', '返聘'],
    ['06', '辞职'],
    ['08', '开除'],
    ['09', '下落不明'],
    ['03', '死亡'],
    ['12', '延聘'],
    ['13', '待退休'],
    ['14', '长病假'],
    ['15', '因公出国'],
    ['16', '停薪留职'],
    ['17', '待岗'],
    ['99', '其他'],
]);

export const schoolTypeConstants = new Map([
    ['1', '幼儿园'],
    ['2', '小学'],
    ['3', '初中'],
    ['4', '高中'],
    ['5', '教育局'],
    ['7', '大中专'],
    ['6', '六年制'],
    ['9', '九年制'],
    ['12', '十二年制'],
    ['10', '特殊教育'],
    ['20', '企业'],
        ['30', '校外机构']

]);

export const politicalCodeConstants = new Map([
    ['1', '中共党员'],
    ['2', '中共预备党员'],
    ['4', '群众'],
    ['5', '民革会员'],
    ['6', '民盟盟员'],
    ['7', '民建会员'],
    ['8', '民进会员'],
    ['9', '农工党党员'],
    ['10', '致公党党员'],
    ['11', '九三学社社员'],
    ['12', '台盟盟员'],
    ['13', '无党派民主人士']
]);

export const educationConstants = new Map([
    ['1', '博士研究生毕业'],
    ['2', '博士研究生结业'],
    ['3', '博士研究生肄业'],
    ['4', '硕士研究生毕业'],
    ['5', '硕士研究生结业'],
    ['6', '硕士研究生肄业'],
    ['7', '研究生班毕业'],
    ['8', '研究生班结业'],
    ['9', '研究生班肄业'],
    ['10', '大学本科毕业'],
    ['11', '大学本科结业'],
    ['12', '大学本科肄业'],
    ['13', '大学普通班毕业'],
    ['14', '大学专科毕业'],
    ['15', '大学专科结业'],
    ['16', '大学专科肄业'],
    ['17', '中等专科毕业'],
    ['18', '中等专科结业'],
    ['19', '中等专科肄业'],
    ['20', '职业高中毕业'],
    ['21', '职业高中结业'],
    ['22', '职业高中肄业'],
    ['23', '技工学校毕业'],
    ['24', '技工学校结业'],
    ['25', '技工学校肄业'],
    ['26', '普通高中毕业'],
    ['27', '普通高中结业'],
    ['28', '普通高中肄业'],
    ['29', '初中毕业'],
    ['30', '初中肄业'],
    ['31', '小学毕业'],
    ['32', '小学肄业'],
    ['33', '其他']
]);

export const educationDegreeConstants = new Map([
    ['1', '学士'],
    ['2', '硕士'],
    ['3', '博士'],
    ['4', '博士后'],
]);

export const teacherMajorConstants = new Map([
    ['1', '学前教育'],
    ['2', '小学教育'],
    ['3', '其他教育'],
    ['4', '中文'],
    ['5', '英语'],
    ['6', '音乐'],
    ['7', '美术'],
    ['8', '体育'],
    ['9', '其他']
]);

export const teacherOrgConstants = new Map([
    ['1', '教师编制'],
    ['2', '其他事业单位编制'],
    ['3', '无任何编制'],
]);

export const teacherCertTypeConstants = new Map([
    ['1', '幼儿教师'],
    ['2', '小学教师'],
    ['3', '中学教师'],
    ['4', '高校教师']
]);

export const parentsNickConstants = new Map([
    ['0', '爸爸'],
    ['1', '妈妈'],
    ['2', '爷爷'],
    ['3', '奶奶'],
    ['4', '外公'],
    ['5', '外婆'],
    ['6', '家长']
]);

export const accountnatureConstants = new Map([
    ['1', '农业户口'],
    ['2', '非农业户口']
]);

export const nonagricultureConstants = new Map([
    ['1', '城市'],
    ['2', '县城'],
    ['3', '乡镇']
]);

export const attendSchoolTypeConstants = new Map([
    ['1', '走读'],
    ['2', '住校'],
]);

export const studentOperationTypeConstants = new Map([
    ['1', '新增'],
    ['2', '删除'],
    ['3', '修改'],
    ['4', '登录'],
    ['5', '用户关注'],
    ['6', '登录第三方'],
    ['7', '转班'],
    ['8', '转出'],
    ['9', '转入'],
    ['10', '新增档案'],
    ['11', '修改档案'],
]);

export const clientTypeConstants = new Map([
    ['1', '企业微信'],
    ['2', '农行'],
    ['12', '企业微信及农行'],
    ['3', '建行生活'],
    ['4', '建行APP']
]);

export default {
    teacherCertTypeConstants,
    teacherTypeConstants,
    positionConstants,
    honoraryTitleConstants,
    schoolTypeConstants,
    peopleStateConstants,
    allPeopleStateConstants,
    politicalCodeConstants,
    educationConstants,
    educationDegreeConstants,
    teacherMajorConstants,
    teacherOrgConstants,
    parentsNickConstants,
    accountnatureConstants,
    nonagricultureConstants,
    attendSchoolTypeConstants,
    studentOperationTypeConstants,
    clientTypeConstants
}



// WEBPACK FOOTER //
// ./src/utils/constants.js